export default __webpack_public_path__ + "static/media/close.d0b9a27f.svg";